import * as yup from 'yup';

export const scheme = yup.object().shape({
  badgeName: yup.string().required('Badge name is required'),
  badgeDescription: yup.string().required('Badge description is required'),
  startDate: yup.string().required('Start date is required'),
  endDate: yup.string().required('End date is required'),
  badgeImage: yup
    .string()
    .required('Badge image is required')
  // publishTime: yup.string().required("Publish time is required"),
});
